<template>
    <div class="NewsIndexWrap">
        <div class="IndexPic">
            <img src="../../assets/Home/newspic.jpg">
        </div>
        <div class="LineCut flexbetween">
            <div class="NewsTitle flexa"><p>GOEASY <span>NEWS</span></p></div>
            <div class="Return flexa" @click="Return"><p>返回</p><img src="../../assets/Home/return.png"></div>
        </div>
        <div class="From flexbetween">
            <p>发布于 2020-07-27 17:45</p>
            <p>来自：cnBeta</p>
        </div>
        <!-- 通用样式模板 -->
        <div class="NewsContent">
            <div class="Title"><p>蒂姆·库克等大型科技公司CEO参加的反垄断听证会改在周三举行</p></div>
            <div class="Text">
                <p>据外媒 Macrumors 报道，苹果公司首席执行官蒂姆·库克 Tim Cook)和其他大型科技公司 CEO 将于周三参加重新安排的反垄断听证会。美国众议院司法机构反垄断小组委员会将举行的听证会本应在周一举行，但为了避免与已故议员约翰-刘易斯的追悼会发生冲突而推迟。</p>
                <img src="../../assets/Home/newspic1.jpg">
                <p>预计库克将与亚马逊 CEO 杰夫·贝佐斯(Jeff Bezos)、Alphabet/谷歌 CEO 桑达尔·皮查伊(Sundar Pichai)和 Facebook CEO 马克·扎克伯格(Mark Zuckerberg)一起出席听证会，这是对这四家科技巨头长达一年多的调查的高潮。</p>
                <p>据悉，库克为此次听证会准备了大半个月的时间，听证会可能会触及广泛的主题，从 App Store 政策、苹果与FBI在提供执法部门访问锁定设备的方法上的争议，到苹果与中国的关系。</p>
                <p>听证会结束后，立法者计划根据他们的调查结果发布一份报告，并提出立法建议，使反垄断法与时俱进，以处理数字市场特有的问题。</p>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'newsindex',
    data() {
      return {};
    },
    methods: {
      Return() {
        this.$router.back();
      }
    }
  };
</script>
<style scoped lang="scss">
    @import '../../../public/Value';
    .NewsIndexWrap{
        width: 100%;
        .NewsContent{
            width: 92%;
            margin: 0.2rem auto;
            .Title{
                width: 100%;
                text-align: center;
                margin-bottom: 0.2rem;
                p{
                    font-size: $TitleSize;
                    color: #fff;
                }
            }
            .Text{
                width: 100%;
                p{
                    font-size: $TextSize;
                    color: #fff;
                    line-height: 0.09rem;
                    margin-bottom: 0.1rem;
                    opacity: 0.8;
                }
                img{
                    width: 2.5rem;
                    margin: 0.1rem auto;
                }
            }
        }
        .IndexPic{
            width: 92%;
            height: 1.2rem;
            margin: 0 auto;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 0.1rem;
            }
        }
        .From{
            width: 90%;
            margin: 0 auto;
            p{
                font-size: $AdditionTextSize;
                color: #fff;
                opacity: 0.6;
            }
        }
        .LineCut{
            width: 90%;
            margin: 0.05rem auto 0.05rem;
            border-bottom: 2px solid #fff;
            .Return{
                cursor: pointer;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                }
                img{
                    width: 0.05rem;
                    margin-left: 0.02rem;
                }
            }
            .NewsTitle{
                p{
                    font-size: $TitleSize;
                    color: #fff;
                    padding-bottom: 0.045rem;
                    span{
                        opacity: 0.6;
                        font-weight: normal;
                    }
                }
            }
        }
    }
</style>
